import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../pages/collateral-property/api/axios';
import { CollateralPropertyPartnerEmployeesData } from '../../pages/collateral-property/types';
import { ICollateralPropertyState } from '../types';
import getUser from './collateralPropertyExtraReducers';

const accessToken: string =
  typeof window !== 'undefined' &&
  localStorage.getItem('propertyAccessToken') !== null &&
  localStorage.getItem('propertyAccessToken') !== '' &&
  localStorage.getItem('propertyAccessToken') !== undefined
    ? localStorage.getItem('propertyAccessToken')!
    : '';

const refreshToken: string =
  typeof window !== 'undefined' &&
  localStorage.getItem('propertyRefreshToken') !== null &&
  localStorage.getItem('propertyRefreshToken') !== '' &&
  localStorage.getItem('propertyRefreshToken') !== undefined
    ? localStorage.getItem('propertyRefreshToken')!
    : '';

const storageProfile: string | null =
  typeof window !== 'undefined' &&
  localStorage.getItem('propertyProfile') !== null &&
  localStorage.getItem('propertyProfile') !== '' &&
  localStorage.getItem('propertyProfile') !== undefined
    ? localStorage.getItem('propertyProfile')!
    : null;

const storageUserId: number | null =
  typeof window !== 'undefined' &&
  localStorage.getItem('propertyUserId') !== null &&
  localStorage.getItem('propertyUserId') !== '' &&
  localStorage.getItem('propertyUserId') !== undefined
    ? Number(localStorage.getItem('propertyUserId')!)
    : null;

const initialState: ICollateralPropertyState = {
  pending: false,
  error: null,
  fulfilled: false,
  auth: accessToken !== '',
  token: accessToken,
  profile: storageProfile !== null ? JSON.parse(storageProfile) : null,
  refreshToken,
  userId: storageUserId,
  roles: [],
};

export const collateralPropertySlice = createSlice({
  name: 'collateralProperty',
  initialState,
  reducers: {
    propertySetAuth: (
      state: Draft<ICollateralPropertyState>,
      action: PayloadAction<boolean>
    ) => {
      state.auth = action.payload;
    },

    propertySetRoles: (
      state: Draft<ICollateralPropertyState>,
      action: PayloadAction<string[]>
    ) => {
      state.roles = action.payload;
    },

    propertySetRefreshToken: (
      state: Draft<ICollateralPropertyState>,
      action: PayloadAction<string>
    ) => {
      state.refreshToken = action.payload;
      localStorage.setItem('propertyRefreshToken', action.payload);
      axios.defaults.headers.common['Refresh-Token'] = action.payload;
    },

    propertySetProfile: (
      state: Draft<ICollateralPropertyState>,
      action: PayloadAction<CollateralPropertyPartnerEmployeesData>
    ) => {
      state.profile = action.payload;
      localStorage.setItem('propertyProfile', JSON.stringify(action.payload));
    },
    propertySetUserId: (
      state: Draft<ICollateralPropertyState>,
      action: PayloadAction<number>
    ) => {
      state.userId = action.payload;
      localStorage.setItem('propertyUserId', action.payload.toString());
    },
    propertySetToken: (
      state: Draft<ICollateralPropertyState>,
      action: PayloadAction<string>
    ) => {
      state.token = action.payload;
      localStorage.setItem('propertyAccessToken', action.payload);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    },

    propertyLogOut: (state) => {
      state.token = '';
      localStorage.removeItem('propertyAccessToken');
      localStorage.removeItem('propertyRefreshToken');
      localStorage.removeItem('propertyProfile');
      localStorage.removeItem('propertyUserId');
      state.auth = false;
      state.profile = null;
      state.roles = [];
      state.userId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.auth = true;
        state.profile = action.payload;
        state.roles = action.payload.roles;
        localStorage.setItem('propertyProfile', JSON.stringify(action.payload));
        state.pending = false;
        state.fulfilled = true;
      })
      .addCase(getUser.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.token = '';
        state.refreshToken = '';
        state.profile = null;
        state.auth = false;
        state.roles = [];
        state.userId = null;

        localStorage.removeItem('propertyAccessToken');
        localStorage.removeItem('propertyRefreshToken');
        localStorage.removeItem('propertyProfile');
        localStorage.removeItem('propertyUserId');

        state.pending = false;
      });
  },
});

export const {
  propertySetAuth,
  propertySetRoles,
  propertySetRefreshToken,
  propertySetProfile,
  propertySetUserId,
  propertySetToken,
  propertyLogOut,
} = collateralPropertySlice.actions;
export default collateralPropertySlice.reducer;
